import React from "react";
import sortDatesIncludingPresent from "../../genericFunctions/sortDatesIncludingPresent";
import getProfileLabel from "../../genericFunctions/getProfileLabel";

const ExperiencesItem = (props) => {
  const experiences = props.experiences;
  const label = (key) => getProfileLabel(props.language, key);
  const mappedExperiences = experiences
    .sort((a, b) => sortDatesIncludingPresent(a.toDate, b.toDate))
    .map((experience) => {
      return (
        <div
          key={experience._id}
          style={{
            borderTop: "1px solid #fff",
            borderBottom: "1px solid #e1e1e1",
            padding: "0px",
            marginBottom: "20px",
          }}
        >
          <h4
            className="print-font"
            style={{ margin: "10px 0px", padding: "0px" }}
          >
            {experience.name}
          </h4>
          <p
            className="print-font"
            style={{
              fontStyle: "italic",
              color: "dark-grey",
              fontSize: "12pt",
              margin: "5px 0px 0px 0px",
            }}
          >
            {`${experience.role} (${
              experience.fromDate !== null
                ? experience.fromDate.slice(0, 7)
                : label("missingDate")
            } - ${
              experience.toDate !== null
                ? experience.toDate.slice(0, 7)
                : label("present")
            })`}
          </p>
          <p
            className="print-font"
            style={{ whiteSpace: "pre-wrap", fontSize: "14pt" }}
          >
            {experience.description}
          </p>
          <p
            style={{
              margin: "0px",
            }}
          >
            {label("tools")}
          </p>
          <p style={{ fontSize: "12pt" }}>{experience.tools}</p>
        </div>
      );
    });

  return mappedExperiences;
};

export default ExperiencesItem;
